import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPayrollRunEmployeesRequest,
  TGetPayrollRunEmployeesResponse,
} from "./getPayrollRunEmployees.schema";

export const getPayrollRunEmployees = (axios: IAxiosInstance) => {
  return async (params: TGetPayrollRunEmployeesRequest) => {
    const { payroll_run_id, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<Array<TGetPayrollRunEmployeesResponse>>
    >(`/api/payroll-runs/${payroll_run_id}/employees`, {
      params: rest,
    });

    return response.data;
  };
};
